import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { useTranslation } from "react-i18next";

export default function ProtectedRoute({ children }) {
    const { t } = useTranslation();
    const { isAuthenticated, isLoading } = useContext(AuthContext);
    const location = useLocation();

    // While verifying auth, render children so Suspense fallbacks
    // (e.g. ProfileSkeleton) display immediately — no spinner flash.
    if (isLoading) {
        return children;
    }

    if (!isAuthenticated) {
        return <Navigate to="/" replace state={{ from: location }} />;
    }

    return children;
}